import React from 'react';
import PropTypes from 'prop-types';
import utils from '@utils';

import './EstimatePreview.scss';

const EstimatePreview = (props) => {
	const {
		toPrevStep, estimate, form, slideToBusinessInfo, slideToJobDateTime, onFinish,
	} = props;

	const {
		TransactionSummaryItems, Tax, RKPayFee, TotalJurisdictionFee, TotalOrganizationFee, WeeklyTotal, Total,
	} = estimate;

	const { jobDateTime } = form;
	const { StartDateTime, EndDateTime } = jobDateTime;
	let RecurrenceEndsOn = null;
	if (jobDateTime.Recurrence) RecurrenceEndsOn = jobDateTime.Recurrence.EndsOn;
	const startDate = new Date(StartDateTime);
	const endDate = RecurrenceEndsOn ? new Date(RecurrenceEndsOn) : new Date(EndDateTime);

	const dateFormat = {
		year : 'numeric', month : 'short', day : 'numeric',
	};

	const timeFormat = {
		hour : '2-digit', minute : '2-digit', hour12 : true,
	};

	return (
		<div className="form-panel panel panel-default">
			<div className="panel-heading text-center">
				<h4 className="panel-title text-primary">{ form.JobEventType }</h4>
			</div>
			<div className="panel-body container-fluid">
				<div className="row panel-row text-center">
					<h4 id="marketplace-estimate-title">Your Estimate Summary</h4>
				</div>

				<div className="marketplace-estimate-section-separator" />

				<div className="row panel-row">
					<div className="col-sm-3 marketplace-estimate-highlight">Business</div>
					<div className="col-sm-1" />
					<div className="col-sm-8">{ form.business.LocationName }</div>
				</div>

				<div className="row panel-row">
					<div className="col-sm-3 marketplace-estimate-highlight">Location</div>
					<div className="col-sm-1" />
					<div className="col-sm-8">
						{ `${form.business.StreetAddress}, ${form.business.City}, ${form.stateName} ${form.business.ZipCode}` }
						<button
							type="button"
							className="btn btn-link edit-info-button"
							onClick={slideToBusinessInfo}
						>
							<i className="rkf rkf-edit" />
						</button>
					</div>
				</div>

				<div className="row panel-row">
					<div className="col-sm-3 marketplace-estimate-highlight">Date</div>
					<div className="col-sm-1" />
					<div className="col-sm-8">
						{ `${startDate.toLocaleString(undefined, dateFormat)}${form.jobDateTime.Recurrence
							? ` to ${endDate.toLocaleString(undefined, dateFormat)}`
							: ''}` }
						<button
							type="button"
							className="btn btn-link edit-info-button"
							onClick={slideToJobDateTime}
						>
							<i className="rkf rkf-edit" />
						</button>
					</div>
				</div>

				<If condition={form.jobDateTime.Recurrence}>
					<div className="row panel-row">
						<div className="col-sm-3 marketplace-estimate-highlight">Recurring</div>
						<div className="col-sm-1" />
						<div className="col-sm-8">{ form.repeatTypeName }</div>
					</div>
				</If>

				<div className="row panel-row">
					<div className="col-sm-3 marketplace-estimate-highlight">Time</div>
					<div className="col-sm-1" />
					<div className="col-sm-8">
						{ `${startDate.toLocaleString(undefined, timeFormat)} - ${endDate.toLocaleString(undefined, timeFormat)}` }
					</div>
				</div>

				<If condition={TransactionSummaryItems && TransactionSummaryItems.length > 0}>
					<div className="marketplace-estimate-section-separator" />

					<div className="row panel-row">
						<div className="col-xs-4 marketplace-estimate-highlight">Description</div>
						<div className="col-xs-2 marketplace-estimate-highlight text-right">Rate</div>
						<div className="col-xs-2 marketplace-estimate-highlight text-right">Hours</div>
						<div className="col-xs-3 marketplace-estimate-highlight text-right">Amount Due</div>
					</div>

					<div className="marketplace-estimate-section-separator" />
					<For
						each="item"
						of={TransactionSummaryItems}
					>
						<div className="row panel-row" key={`estimate_preview_fee_${item.Id}`}>
							<div className="col-xs-4">
								{item.JobTitle}
							</div>
							<div className="col-xs-2 text-primary text-right">
								{utils.currencyFormatter(item.Rate)}
							</div>
							<div className="col-xs-2 text-primary text-right">
								{item.Hours}
							</div>
							<div className="col-xs-3 text-primary text-right">
								{utils.currencyFormatter(item.Amount)}
							</div>
						</div>
					</For>
				</If>

				<div className="marketplace-estimate-section-separator" />

				<div className="row panel-row">
					<div className="col-xs-8 text-right marketplace-estimate-highlight">Fees and Taxes</div>
					<div className="col-xs-3 marketplace-estimate-highlight text-right">
						{ utils.currencyFormatter(Tax + RKPayFee + TotalJurisdictionFee + TotalOrganizationFee) }
					</div>
				</div>
				<div className="row panel-row">
					<div className="col-xs-8 text-right marketplace-estimate-highlight">Total Estimate</div>
					<div className="col-xs-3 marketplace-estimate-highlight text-right">{ utils.currencyFormatter(Total) }</div>
				</div>
				<If condition={form.jobDateTime.Recurrence}>
					<div className="row panel-row">
						<div className="col-xs-8 text-right marketplace-estimate-highlight">Total Estimate (Weekly)</div>
						<div className="col-xs-3 marketplace-estimate-highlight text-right">{ utils.currencyFormatter(WeeklyTotal) }</div>
					</div>
				</If>

				<div className="row marketplace-action-buttons-container">
					<button
						type="button"
						className="btn btn-link col-xs-8 col-xs-offset-2 col-sm-4 col-sm-offset-1"
						onClick={toPrevStep}
					>
						Back
					</button>

					<button
						type="submit"
						className="btn btn-primary col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-0"
						onClick={() => onFinish()}
					>
						Request Job
					</button>
				</div>
			</div>
		</div>

	);
};

EstimatePreview.propTypes = {
	form                : PropTypes.object,
	estimate            : PropTypes.object,
	toPrevStep          : PropTypes.func.isRequired,
	onFinish            : PropTypes.func.isRequired,
	slideToJobDateTime  : PropTypes.func.isRequired,
	slideToBusinessInfo : PropTypes.func.isRequired,
};

EstimatePreview.defaultProps = {
	estimate : {},
	form     : {},
};

export default EstimatePreview;
